<template>
    <eod-card flat>
        <template v-slot:header>
            <v-card-title class="text-body-1 pb-4">
            <eod-btn  class="ml-2" @click="selectProductTypeDialog = true" color="primary" depressed rounded small><v-icon left>mdi-plus</v-icon>Toevoegen</eod-btn>
            </v-card-title>
        </template>
            <v-card-text>
                <eod-expansion-panels v-if="value && value.length > 0">
                    <v-expansion-panel v-for="productType in value" :key="productType.id">
                        <v-expansion-panel-header>
                            <div class="d-flex align-items-center">
                            {{productType.name}}
                            <v-spacer></v-spacer>
                             <v-btn @click.stop="deleteItem(productType)" color="error" icon small><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                             </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-card-title class="text-body-1 pb-4 px-0">Standaard instellingen
                                <eod-btn  class="ml-2" @click="addIndicativeValue(productType)" color="primary" depressed rounded small><v-icon left>mdi-plus</v-icon>Toevoegen</eod-btn>
                            </v-card-title>
                            <table class="w-100">
                                <thead>
                                    <tr>
                                    <th class="text-left px-2 py-2" width="260">Van</th>
                                    <th class="text-left px-2 py-2" width="260">Tot</th>
                                    <th class="text-left px-2 py-2">Waarde</th>
                                    <th class="text-left px-2 py-2" width="40"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(setting, settingIndex) in productType.settings" :key="productType.id+'_'+settingIndex">
                                        <td class="text-left px-2 py-2">
                                            <eod-text-field type="date" clearable hide-details :value="setting.starttime?$moment(setting.starttime).format('YYYY-MM-DD'):null" :rules="[
                                                val => (!checkBothFilled(val, setting.endtime)?(productType.name+': Instelling \'van\' en \'tot\' moeten beide ingevuld zijn, of beide leeg zijn'):true),
                                                val => (!checkOverlap(productType, settingIndex)?(productType.name+': \'van\' en \'tot\' van verschillende instellingen mogen niet overlappen!'):true),
                                                val => (val && val >= setting.endtime?(productType.name+': \'Van\' moet kleiner zijn dan \'tot\''):true),
                                                val => (!val && productType.settings.filter(item => (!item.starttime && !item.endtime)).length > 1?(productType.name+': Er mag slechts 1 instelling geen \'Van\' en \'Tot\' hebben'):true)
                                            ]" @input="val => {productType.settings[settingIndex].starttime = val;updateProductType(productType)}"></eod-text-field>
                                        </td>
                                        <td class="text-left px-2 py-2">
                                            <eod-text-field type="date" clearable hide-details :value="setting.endtime?$moment(setting.endtime).format('YYYY-MM-DD'):null"  @input="val => {productType.settings[settingIndex].endtime = val;updateProductType(productType)}"></eod-text-field>
                                        </td>
                                        <td class="text-left px-2 py-2">
                                            <eod-text-field type="number" step="0.01" v-model="setting.value" hide-details :rules="[val => $validator.required(val, productType.name+': Instelling waarde')]" @input="updateProductType(productType)"></eod-text-field>
                                        </td>
                                        <td class="text-left px-2 py-2">
                                            <v-btn @click.stop="deleteSetting(productType, settingIndex)" color="error" icon small><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </eod-expansion-panels>
                <v-alert v-else type="info" text>Geen instellingen gevonden voor geselecteerde meetwaarde</v-alert>
            </v-card-text>
            <eod-object-selector multiple v-if="selectProductTypeDialog" v-model="selectProductTypeDialog" :disabled="value?value.map(item => item.id):[]" endpoint="productTypes" label="Kies een asset type" :fields="['id','name']" @click="addProductType"></eod-object-selector>
        </eod-card>

</template>

<script>
import eodObjectSelector from './eod-object-selector.vue';

export default{
    components:{
        eodObjectSelector
    },
    props:{
        value: Array,
    },
    data: () => {
        return {
            selectProductTypeDialog:false,
        }
    },
    methods:{
        updateProductType(productType){
            const val = this.value.map(item => item.id == productType.id?productType:item);
            this.$emit('input', val);
        },
        checkOverlap(productType, checkIndex){
            const check = productType.settings[checkIndex];
            if(!check.starttime){
                return true;
            }
            for (let i = 0; i < productType.settings.length; i++) {
                if(i === checkIndex){
                    continue;
                }

                const toCheck = productType.settings[i];
                if(toCheck.starttime){
                    if(check.starttime < toCheck.endtime && check.endtime > toCheck.starttime){
                        return false;
                    }
                }
            }

            return true;
        },
        checkBothFilled(val1, val2){
            if((val1 && val2) || (!val1 && !val2)){
                return true;
            }

            return false;
        },
        deleteSetting(productType, index){
            productType.settings.splice(index, 1);
            this.updateProductType(productType);
        },
        deleteItem(item){
            const val = this.value;
            for (let i = 0; i < val.length; i++) {
                if(val[i].id == item.id){
                    val.splice(i, 1);
                };
            }
            this.$emit('input', val);
        },
        addIndicativeValue(productType){
            if(!productType.settings){
                productType.settings = [];
            }

            productType.settings.push({
                starttime: null,
                endtime: null,
                value: null,
            });

            const val = this.value.map(item => item.id == productType.id?productType:item);
            this.$emit('input', val);
        },
        addProductType(items){
            let val = this.value;

            if(!val){
                val = [];
            }

            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if(!val.map(productType => productType.id).includes(item.id)){
                    val.push(item);
                } else {
                    this.$toaster.notify({
                            type: 'warning',
                            title: this.$t('Bestaand asset type'),
                            body: this.$t('Asset type reeds gekoppeld aan meetwaarde')
                        });
                }
            }

            this.selectProductTypeDialog = false;

            this.$emit('input', val);
        },
    }
}
</script>
